import { deleteSubrubro, getSubrubrosPanel} from "../../services/SubrubrosServices";
import { SubrubrosContext } from "./SubrubrosContext"

export const SubrubrosState = ({ children }) => {
    
    const getSubrubrosPanelData = async (searchTerm,searchFilter ,secondSearchFilter,numpag,filas) => {
        let res = await getSubrubrosPanel(searchTerm,searchFilter ,secondSearchFilter,numpag,filas)
        return res
    }
     
    const deleteSubrubroData = async (body,searchTerm,searchFilter ,secondSearchFilter,numpag,filas) => {
        const res = await deleteSubrubro(body)
        if (res) getSubrubrosPanelData(searchTerm,searchFilter ,secondSearchFilter,numpag,filas)
        return res
    }

    return <SubrubrosContext.Provider value={{
        deleteSubrubroData,
        getSubrubrosPanelData,
    }} >
        {children}
    </SubrubrosContext.Provider>
}